export default {
  Error: {
    404: "OPP! Không tìm thấy trang.",
    "404_sub": "Đường dẫn đang truy cập đã bị thay đổi hoặc không tồn tại",
    500: "Internal Server Error!",
    "500_sub": "Có một số lỗi xảy ra, vui lòng liên hệ với MISA để được trợ giúp",
    403: "Không có quyền truy cập",
    "403_sub": "Bạn vui lòng liên hệ với admin để được cấp quyền truy cập ứng dụng",

    // hạn dùng
    "555_list_user": "Danh sách quản trị hệ thống:",
    // dùng thử
    "555_type1_title_trial": "HẾT HẠN DÙNG THỬ PHẦN MỀM",
    "555_type1_error_trial_admin":
      "Thuê bao dùng thử của quý khách đã hết hạn từ ngày <b>{0}</b>. Vui lòng mua thuê bao chính thức để tiếp tục sử dụng phần mềm.",
    "555_type1_error_trial":
      "Thuê bao dùng thử của quý khách đã hết hạn từ ngày <b>{0}</b>. Vui lòng liên hệ với quản trị hệ thống thực hiện mua thuê bao chính thức để tiếp tục sử dụng phần mềm.",

    // chính thức
    "555_type1_title_office": "HẾT HẠN SỬ DỤNG PHẦN MỀM",
    "555_type1_error_office":
      "Thuê bao của quý khách đã hết hạn từ ngày <b>{0}</b>. Vui lòng liên hệ với quản trị hệ thống thực hiện gia hạn để tiếp tục sử dụng phần mềm.",
    "555_type1_error_office_admin":
      "Thuê bao của quý khách đã hết hạn từ ngày <b>{0}</b>. Vui lòng liên hệ thực hiện gia hạn để tiếp tục sử dụng phần mềm.",

    "555_type1_content_error":
      "Sau 30 ngày kể từ khi hết hạn, hệ thống sẽ thực hiện cắt quyền truy cập, xóa dữ liệu công ty của quý khách trên MISA AMIS PLATFORM.",

    // tài nguyên số lượng người dùng
    // là admin
    "555_type2_title": "QUÁ SỐ LƯỢNG NGƯỜI DÙNG CHO PHÉP",
    "555_type2_error_admin":
      "Số lượng người dùng đang sử dụng quá hạn mức cho phép: Đã mua <b>{0}</b> người dùng, Đã sử dụng <b>{1}</b> người dùng. Vui lòng thực hiện nâng cấp thuê bao hoặc xóa bớt người dùng khỏi ứng dụng để đảm bảo hoạt động của chương trình.",
    // user thường
    "555_type2_error":
      "Số lượng người dùng đang sử dụng quá hạn mức cho phép: Đã mua <b>{0}</b> người dùng, Đã sử dụng <b>{1}</b> người dùng. Vui lòng liên hệ với quản trị hệ thống thực hiện nâng cấp thuê bao hoặc xóa bớt người dùng khỏi ứng dụng để đảm bảo hoạt động của chương trình.",
  },
  Button: {
    BackAmis: "Quay lại",
    ByNow: "Mua ngay",
    ActiveNow: "Gia hạn ngay",
    DeleteUser: "Xóa người dùng",
  },
};
